import Stepper from '@codegouvfr/react-dsfr/Stepper';
import React, {ReactNode, useState} from 'react';
import {Outlet} from "react-router-dom";
import { StepperInfo } from './types/stepper-info.type';

export const StepperPage = () => {
  const [stepperInfo, setStepperInfo] = useState<StepperInfo>({
    currentStep: 1,
    title: '?',
  });

  return (
    <div>
        <Stepper
          currentStep={stepperInfo.currentStep}
          nextTitle={stepperInfo.nextTitle as ReactNode | undefined}
          stepCount={3}
          title={stepperInfo.title}
        />

        <div className={'separator'} />

        <Outlet context={{ stepperInfo, setStepperInfo }}/>
    </div>
  );
};
